document.addEventListener('DOMContentLoaded', function () {
	const initContentSectionTables = () => {
		// Find all content-section blocks
		const contentSections = document.querySelectorAll(
			'.block-content-section'
		);

		contentSections.forEach((section) => {
			// Find tables within this section
			const table = section.querySelector('.wp-block-table table');

			if (!table) {
				return;
			}

			// Get all tbody rows (excluding header rows)
			const tbody = table.querySelector('tbody');
			if (!tbody) {
				return;
			}

			const rows = tbody.querySelectorAll('tr');

			// Only proceed if there are more than 5 rows
			if (rows.length <= 5) {
				return;
			}

			// Check if toggle button already exists (to avoid duplicates)
			if (section.querySelector('.content-section__table-toggle')) {
				return;
			}

			// Initially hide rows beyond the 5th
			rows.forEach((row, index) => {
				if (index >= 5) {
					row.style.display = 'none';
					row.classList.add('content-section__hidden-row');
				}
			});

			// Create the toggle button
			const toggleButton = document.createElement('button');
			toggleButton.className =
				'content-section__table-toggle wp-block-button__link is-style-tertiary';
			toggleButton.type = 'button';

			// Create button text span
			const buttonText = document.createElement('span');
			buttonText.textContent = 'Show More';
			toggleButton.appendChild(buttonText);

			// Create icon span
			const buttonIcon = document.createElement('span');
			buttonIcon.className =
				'wp-block-button__icon wp-block-button__icon--right';
			buttonIcon.style.maskImage = 'var(--icon-maximize)';
			buttonIcon.style.webkitMaskImage = 'var(--icon-maximize)';
			toggleButton.appendChild(buttonIcon);

			// Create wrapper div for button
			const buttonWrapper = document.createElement('div');
			buttonWrapper.className =
				'wp-block-button is-style-tertiary wp-block-button--icon-right content-section__table-toggle-wrapper';
			buttonWrapper.appendChild(toggleButton);

			// Insert button after the table's parent block
			const tableBlock = section.querySelector('.wp-block-table');
			if (tableBlock) {
				tableBlock.insertAdjacentElement('afterend', buttonWrapper);
			}

			// Track expanded state
			let isExpanded = false;

			// Add click handler
			toggleButton.addEventListener('click', function () {
				isExpanded = !isExpanded;

				if (isExpanded) {
					// Show all rows
					rows.forEach((row) => {
						row.style.display = '';
						row.classList.remove('content-section__hidden-row');
					});

					// Update button text and icon
					buttonText.textContent = 'Show Less';
					buttonIcon.style.maskImage = 'var(--icon-minimize)';
					buttonIcon.style.webkitMaskImage = 'var(--icon-minimize)';
				} else {
					// Hide rows beyond the 5th
					rows.forEach((row, index) => {
						if (index >= 5) {
							row.style.display = 'none';
							row.classList.add('content-section__hidden-row');
						}
					});

					// Update button text and icon
					buttonText.textContent = 'Show More';
					buttonIcon.style.maskImage = 'var(--icon-maximize)';
					buttonIcon.style.webkitMaskImage = 'var(--icon-maximize)';

					// Scroll table into view if needed
					const tableRect = table.getBoundingClientRect();
					if (tableRect.top < 0) {
						table.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					}
				}
			});
		});
	};

	// Initialize on page load
	initContentSectionTables();

	// Re-initialize when new blocks are added in the editor
	if (window.wp && window.wp.data) {
		window.wp.data.subscribe(() => {
			setTimeout(initContentSectionTables, 100);
		});
	}
});
